import type { WalletButtonsVisibility } from "../../config";

export type WalletServiceType = "apple" | "google" | null;

export const getWalletService = (): WalletServiceType => {
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone/.test(ua)) return "apple";
  if (/android/.test(ua)) return "google";
  return null;
};

export const isWalletButtonVisible = (
  visibility: WalletButtonsVisibility = "all",
  service: WalletServiceType
): boolean => {
  return !!service && visibility !== "none" && (visibility === "all" || visibility === service);
};
